var _text, _g, _g2, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBbsId(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGRoot",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46.184914,
    y: 34.617729,
    fill: "#000000",
    fontFamily: "'Yu Gothic UI'",
    fontSize: "21.333px",
    fontWeight: 600,
    strokeLinecap: "round",
    strokeMiterlimit: 3.3,
    strokeWidth: 0.6274,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", null))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.50495 2.9986)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93735 0 0 .93534 .1497 8.8346)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.2075,0,0,2.2117,-17.129,-38.193)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.013732 .67169)",
    fillOpacity: 0,
    stroke: "#94a3b8",
    strokeLinecap: "round",
    strokeMiterlimit: 3.3,
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.3193 21.988c0.18733-1.2698 1.2744-2.4148 2.3301-3.145 1.5794-1.0924 3.6047-1.5989 5.5225-1.6998 1.9804-0.10422 4.1235 0.31697 5.9551 1.0774 0.78512 0.32596 1.6239 0.98227 2.1626 1.6399 0.53758 0.65622 0.90948 1.6491 1.0024 2.4923 0.06311 0.57246-0.03329 1.2276-0.24161 1.8208-0.11537 0.32852-0.26506 0.63807-0.44101 0.9041-0.37943 0.57369-1.2529 0.65435-1.6875 1.1875-0.33011 0.40501-0.52636 0.9244-0.625 1.4375-0.12984 0.67545 0.2824 1.6371-0.28125 2.0312-0.64357 0.45008-1.0559-0.71444-1.6846-1.1851-0.59385-0.44462-0.70253-1.0808-1.3669-1.4108-1.0823-0.53764-2.5434-0.1448-3.7356-0.34287-1.3389-0.22244-2.7095-0.37705-3.9316-0.96741-0.81164-0.39209-1.6995-0.78623-2.25-1.5-0.43052-0.55823-0.83042-1.6423-0.72754-2.3397z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.044 27.168s-0.78352-1.5554-1.3562-2.2307c-0.50936-0.60065-1.875-1.4375-1.875-1.4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.333 17.248s0.04486 1.4236 0.40625 2c0.43828 0.69898 1.9688 1.5 1.9688 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.22 23.219s0.45689-0.98661 0.70487-1.308c0.24798-0.32143 0.81829-0.63393 1.1076-0.72321 0.70129-0.21638 1.7188 0.03125 1.7188 0.03125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.781 23.01s1.2005 0.28404 1.898 0.32746c0.56228 0.03501 1.5989-0.25646 2.0248-0.62526 0.37332-0.32335 0.63621-1.6963 0.63621-1.6963"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#94a3b8"
  }, /*#__PURE__*/React.createElement("text", {
    x: 3.1541216,
    y: 35.651134,
    fontSize: "8px",
    style: {
      inlineSize: 15.5775,
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.66667)",
    style: {
      shapeInside: "url(#rect1231)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 3.3
  }, /*#__PURE__*/React.createElement("text", {
    x: 4.2532854,
    y: 35.125446,
    fontSize: "8px",
    strokeWidth: 0.41827,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.2532854,
    y: 35.125446,
    strokeWidth: 0.41827
  })), /*#__PURE__*/React.createElement("text", {
    x: 0.93746006,
    y: 38.489719,
    fontFamily: "'Yu Gothic UI'",
    fontSize: "14.987px",
    fontWeight: 600,
    strokeWidth: 0.44077,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.93746006,
    y: 38.489719,
    fontFamily: "'Yu Gothic UI'",
    fontSize: "14.987px",
    fontWeight: 600,
    strokeWidth: 0.44077
  }, "BBS")), /*#__PURE__*/React.createElement("text", {
    x: 34.121864,
    y: 43.775387,
    fontFamily: "'Yu Gothic UI'",
    fontSize: "14.222px",
    fontWeight: 600,
    strokeWidth: 0.41827,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34.121864,
    y: 43.775387,
    strokeWidth: 0.41827
  })))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 34.574642,
    y: 45.001827,
    fill: "#94a3b8",
    fontFamily: "'Yu Gothic UI'",
    fontSize: "24.942px",
    fontWeight: "bold",
    strokeLinecap: "round",
    strokeMiterlimit: 3.3,
    strokeWidth: 0.73355,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34.574642,
    y: 45.001827,
    fill: "#94a3b8",
    strokeWidth: 0.73355
  }, "ID")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 46.939293,
    y: 16.596394,
    fill: "#000000",
    fontFamily: "'Yu Gothic UI'",
    fontSize: "21.333px",
    fontWeight: "bold",
    strokeLinecap: "round",
    strokeMiterlimit: 3.3,
    strokeWidth: 0.6274,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 46.939293,
    y: 16.596394
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbsId);
export default __webpack_public_path__ + "static/media/BBS_ID.b7dc7c9e9f1f028d273f60e522d37145.svg";
export { ForwardRef as ReactComponent };